import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  LayoutDashboard,
  Building2,
  Users,
  Server,
  Package,
  Receipt,
  Clock,
  TrendingUp,
  Mail,
  Settings,
  X,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useSidebarStore } from '@/stores/sidebarStore';
import { RoutesConfig } from '@/navigation/routes';

const navItems = [
  { key: 'dashboard', icon: LayoutDashboard, path: RoutesConfig.Dashboard.fullPath },
  { key: 'companies', icon: Building2, path: RoutesConfig.Companies.fullPath },
  { key: 'users', icon: Users, path: RoutesConfig.Users.fullPath },
  { key: 'machines', icon: Server, path: RoutesConfig.Machines.fullPath },
  { key: 'products', icon: Package, path: RoutesConfig.Products.fullPath },
  { key: 'transactions', icon: Receipt, path: RoutesConfig.Transactions.fullPath },
  { key: 'sessions', icon: Clock, path: RoutesConfig.Sessions.fullPath },
  { key: 'revenue', icon: TrendingUp, path: RoutesConfig.Revenue.fullPath },
  { key: 'emails', icon: Mail, path: RoutesConfig.Emails.fullPath },
  { key: 'settings', icon: Settings, path: RoutesConfig.Settings.fullPath },
];

export function MobileSidebar() {
  const { t } = useTranslation();
  const { isMobileOpen, setMobileOpen } = useSidebarStore();

  if (!isMobileOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 z-40 bg-black/50 lg:hidden"
        onClick={() => setMobileOpen(false)}
      />

      {/* Sidebar */}
      <aside className="fixed inset-y-0 left-0 z-50 w-64 bg-card border-r lg:hidden flex flex-col">
        <div className="h-16 flex items-center justify-between px-4 border-b">
          <span className="font-bold text-lg text-primary">VendWallet</span>
          <button
            onClick={() => setMobileOpen(false)}
            className="p-1.5 rounded-md hover:bg-accent"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-4 px-2">
          <ul className="space-y-1">
            {navItems.map((item) => (
              <li key={item.key}>
                <NavLink
                  to={item.path}
                  end={item.path === '/'}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-primary/10 text-primary'
                        : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                    )
                  }
                >
                  <item.icon className="h-5 w-5 shrink-0" />
                  <span>{t(`nav.${item.key}`)}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
}
